import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import siteData from '../services/siteData';
import Menu from '../components/Menu';
import Footer from '../components/Footer';

export default class BaseLayout extends React.PureComponent {
  render() {
    const { children } = this.props;

    return (
      <>
        <Helmet>
          <title>{siteData.title}</title>
          <meta name="theme-color" content="#ffffff" />
        </Helmet>
        <header
          id="BaseLayout__header"
          className="BaseLayout__header"
        >
          <Link
            to="/"
            className="BaseLayout__link"
          >
            <img
              src={`${process.env.PUBLIC_URL}/pig.svg`}
              alt="Utopia Films"
              className="BaseLayout__pig"
            />
          </Link>
          <Menu />
        </header>
        <div className="BaseLayout__content">
          <main>{children}</main>
          <Footer />
        </div>
      </>
    );
  }
}

BaseLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]).isRequired,
};
